<div class="reusable-alert-popup-backdrop" *ngIf="visible" (click)="onBackdropClick($event)">
  <div class="reusable-alert-popup-card" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
    <div class="reusable-alert-popup-header" *ngIf="translatedTitle">
      <div class="reusable-alert-popup-title">{{ translatedTitle }}</div>
      <button type="button" class="close-button" (click)="handleClose()" aria-label="Close">
        <img src="assets/icons/close_black.svg" alt="close" />
      </button>
    </div>

    <div class="reusable-alert-popup-content">
      <div class="reusable-alert-popup-icon" aria-hidden="true">
        <span>{{ iconText }}</span>
      </div>

      <p class="reusable-alert-popup-message" *ngIf="translatedMessage">
        {{ translatedMessage }}
      </p>
    </div>

    <div class="reusable-alert-popup-actions" [ngClass]="{
        'single-action': !(showPrimaryButton && showSecondaryButton),
      }">
      <button *ngIf="showPrimaryButton" type="button" class="popup-button popup-button-primary"
        (click)="handlePrimaryAction()">
        {{ translatedPrimaryButtonLabel }}
      </button>

      <button *ngIf="showSecondaryButton" type="button" class="popup-button popup-button-secondary"
        (click)="handleSecondaryAction()">
        {{ translatedSecondaryButtonLabel }}
      </button>
    </div>
  </div>
</div>